import { css } from 'linaria';
import { strictBreakpoints } from '../../../media';

export const stepsContainerStyles = css`
	display: grid;
	grid-gap: 24px;
	grid-template-columns: repeat(4, 1fr);
	margin-top: 24px;
	${strictBreakpoints.onlyTablet} {
		grid-template-columns: 1fr 1fr;
		grid-template-rows: 1fr max-content;
	}
	${strictBreakpoints.onlyMobile} {
		grid-template-columns: 1fr;
		grid-template-rows: repeat(1fr, 4);
	}
`;
